import React from "react";

const ITEMS = [
  "100% FREE TO APPLY & APPEAR",
  "NO COST. NO CATCH. JUST YOUR STORY.",
  "THE VOICE OF THE PRODUCERS",
];

function Sequence() {
  // Render the list a few times for seamless looping; separator slashes
  const repeated = Array.from({ length: 4 }).flatMap(() => ITEMS);
  return (
    <div className="flex items-center gap-10 pr-10 whitespace-nowrap">
      {repeated.map((txt, i) => (
        <React.Fragment key={i}>
          <span className="text-[11px] md:text-xs font-bold tracking-[0.22em] text-[#f5c451]">
            {txt}
          </span>
          <span className="text-white/15 select-none">/</span>
        </React.Fragment>
      ))}
    </div>
  );
}

export default function MarqueeTicker() {
  return (
    <div className="relative w-full overflow-hidden bg-[#050608] py-3 z-30">
      {/* edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#050608] to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#050608] to-transparent z-10" />

      <div className="flex marquee-track">
        <Sequence />
        <Sequence />
      </div>
    </div>
  );
}
